module.exports = __webpack_public_path__ + "img/ico-abf@2x.0d59ea0c.png";